'use client';

import Image from 'next/image';
import { Box } from '@/primitives';

/** Intrinsic size of hero PNGs in public/images (update if assets change). */
const HERO_WIDTH = 1024;
const HERO_HEIGHT = 626;

const getStartedAssets = {
  search: {
    src: '/images/database-search-hero.png',
    alt: '',
  },
  registry: {
    src: '/images/registry-hero.png',
    alt: '',
  },
} as const;

type GetStartedPreviewProps = {
  cardId: 'search' | 'registry';
  /** Stretch preview area so paired path cards share equal height */
  expandToFill?: boolean;
};

export function GetStartedPreview({
  cardId,
  expandToFill = false,
}: GetStartedPreviewProps) {
  const { src, alt } = getStartedAssets[cardId];

  return (
    <Box
      sx={{
        width: '100%',
        ...(expandToFill && {
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }),
      }}
    >
      <Box
        sx={{
          width: '100%',
          position: 'relative',
          backgroundColor: 'transparent',
          lineHeight: 0,
          ...(expandToFill
            ? {
                flex: 1,
                minHeight: { xs: 220, md: 280 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }
            : {
                minHeight: 200,
              }),
        }}
      >
        <Image
          alt={alt}
          height={HERO_HEIGHT}
          sizes="(max-width: 900px) 100vw, 560px"
          src={src}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '100%',
            display: 'block',
            objectFit: 'contain',
            objectPosition: 'top center',
            verticalAlign: 'top',
          }}
          width={HERO_WIDTH}
        />
      </Box>
    </Box>
  );
}
